export default "__VITE_ASSET__e0892ea3__"